import Pageheader from 'components/Pageheader';
import React, { useEffect, useState, useContext } from 'react';
import ModalContext from 'contexts/ModalContext';
import { Helmet } from "react-helmet";
import { GetAllBrand } from 'services/Api/Module/Brand';
import { useNavigate } from 'react-router-dom';
import useTranslations from 'i18n/useTranslations';
import PullToRefresh from 'components/pullToRefresh/PullToRefresh';
const RestaurantAll = () => {
    const navigate = useNavigate();
    const [refreshing, setRefreshing] = useState(false)
    const { lang, supportedLangs, setLang } = useTranslations(); // สำหรับเปลี่ยนภาษา
    const { t } = useTranslations();

    const [brand, setBrand] = useState([]);
    const [search, setSearch] = useState([]);
    const [groups, setGroups] = useState({});
    const [randomBrands, setRandomBrands] = useState([]);
    const { mAlert } = useContext(ModalContext);

    const handleBack = () => {
        navigate("/coupon-all");
    };
    const fetchGetAllBrand = async () => {
        try {
            const response = await GetAllBrand();
            const resData = response?.data;
            if (resData.resultCode === 20000) {
                const remainingBrands = resData.resultData.filter(item => item.id != 21);
                setBrand(remainingBrands);
            } else {
                mAlert.info({
                    title: "ไม่พบ brand",
                    subTitle: "ไม่พบ brand",
                    content: "",
                    onClose: () => { },
                });
            }
            setRefreshing(false)
        } catch (err) {
            setRefreshing(false)
            console.log('err ', err);
            mAlert.info({
                title: "แจ้งเตือน",
                subTitle: "มีบางอย่างผิดพลาด",
                content: "",
                onClose: () => { },
            });
        }
    };
    const handleRefresh = () => {
        console.log('handleRefresh!!!')
        setRefreshing(true)
        onLoad();
    }
    const onLoad = () => {
        fetchGetAllBrand();
    }

    useEffect(() => {
        onLoad();
    }, []);

    useEffect(() => {
        if (brand.length > 0) {
            const randomBrand = getRandomBrands(brand, 4);
            console.log("Random brands:", randomBrand); // Debug log
            setRandomBrands(randomBrand);
        }
    }, [brand]);

    const getRandomBrands = (brands, count) => {
        const shuffled = brands?.sort(() => 0.5 - Math.random());
        return shuffled?.slice(0, count);
    };

    const groupedBrandsEn = (brands) => {
        const grouped = {};
        brands.forEach((item) => {
            const firstLetter = item.nameEn[0].toUpperCase();
            if (!grouped[firstLetter]) {
                grouped[firstLetter] = [];
            }
            grouped[firstLetter].push(item);
        });


        let ans = []
        for (let key of Object.keys(grouped).sort()) {
            const tmp = {
                groupName: key,
                items: grouped[key]
            }
            ans.push(tmp)
        }
        return ans;
    };
    const groupedBrandsTh = (brands) => {
        const grouped = {};
        brands.forEach((item) => {
            const firstLetter = item.nameTh[0].toUpperCase();
            if (!grouped[firstLetter]) {
                grouped[firstLetter] = [];
            }
            grouped[firstLetter].push(item);
        });

        let ans = [];
        for (let key of Object.keys(grouped).sort()) {
            const tmp = {
                groupName: key,
                items: grouped[key]
            };
            ans.push(tmp);
        }
        return ans;
    };

    const handleNavigate = (id) => {
        navigate(`/coupon-all?restaurantId=${id}`);
    };


    return (
        <>
            <PullToRefresh
                refreshing={refreshing}
                onRefresh={handleRefresh}
            >
                <Helmet>
                    <title>IMPACT Family</title>
                    <meta name="title" content="Impact Family" />
                    <meta name="description" content="Impact Family" />
                    <meta name="keyword" content="" />
                    <meta property="og:title" content="Impact Family" />
                    <meta property="og:description" content="Impact Family" />
                    <meta property="og:image" content="" />
                    <meta property="og:url" content="" />
                    <meta property="og:type" content="website" />
                    <meta property="og:site_name" content="Impact Family" />
                </Helmet>
                <div id="pageListRestaurant">
                    <Pageheader pagename='IMPACT TOP SELECTED' onClick={handleBack} />

                    <main id="top">
                        <div className="wrapContent">
                            <section id="pSearch">
                                <div className="bSearch bForm">
                                    <div className="control-group">
                                        <input type="text" placeholder={lang == "th" ? 'ค้นหาชื่อร้าน' : 'Search Restaurant'} onChange={(e) => setSearch(e.target.value.toLowerCase())} />
                                    </div>
                                </div>
                                <div className="bRestaurant">
                                    <nav>
                                        {/* <!-- หลังจากที่เลือกร้านค้่ามาจากหน้า ร้านค้าทั้งหมด ให้ใส่ className active ที่ nav --> */}
                                        {randomBrands?.map((item, index) => (
                                            <a key={index} onClick={() => handleNavigate(item.id)}>
                                                <div className="bLogo">
                                                    <img src={item.logoImg} alt={item.nameEn} />
                                                </div>
                                                <span>{item.name}</span>
                                            </a>
                                        ))}
                                    </nav>
                                </div>
                            </section>
                            <section id="pListRestaurant">
                                <div className="bListRestaurant">
                                    {(lang === "th" ? groupedBrandsTh : groupedBrandsEn)(
                                        brand.filter(item => 
                                            item.nameTh.toLowerCase().includes(search) || item.nameEn.toLowerCase().includes(search)
                                        )
                                    ).map((item0) => (
                                        <div className="bGroup" key={item0.groupName}>
                                            <div className="bGroupName">
                                                <h2>{item0.groupName}</h2>
                                            </div>
                                            <div className="bGroupList">
                                                {item0.items?.map((item1) => (
                                                    <a onClick={() => handleNavigate(item1.id)} key={item1.id}>
                                                        <article>
                                                            <div className="bLogo">
                                                                <img src={item1.logoImg} alt={item1.name} />
                                                            </div>
                                                            <div className="bName">
                                                                <h3>{item1.name}</h3>
                                                            </div>
                                                        </article>
                                                    </a>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </section>

                            <div className="bBtnTop"><a className="btnTop" href="#top"></a></div>

                        </div>
                    </main>
                </div>
            </PullToRefresh>
        </>
    )
}

export default RestaurantAll